/* global window */
/* global document */
/* global location */
/* eslint no-restricted-globals: ["error", "event"] */

import {routerRedux} from 'dva/router'
import {config} from '../utils'
import service from '../services/app'
import {stringify, parse} from 'qs'

const {prefix} = config

export default {
  namespace: 'app',
  state: {
    user: null,
    ready: false,
    locationPathname: '',
    locationQuery: {},
  },
  subscriptions: {

    setupHistory({dispatch, history}) {
      history.listen((location) => {
        dispatch({
          type: 'updateState',
          payload: {
            locationPathname: location.pathname,
            locationQuery: parse(location.search),
          },
        })

        if (location.pathname.indexOf('/ticket') >= 0) {
          dispatch({
            type: 'updateState',
            payload: {
              loginTo: 'ticket'
            }
          })
        }
        if (location.pathname.indexOf('/group-apply') >= 0) {
          dispatch({
            type: 'updateState',
            payload: {
              loginTo: 'groupApply'
            }
          })
        }
      })
    },

    setup({dispatch}) {
      dispatch({type: 'query'})
    },

  },
  effects: {

    * query({
              payload,
            }, {call, put, select}) {
      yield put({type: 'updateState', payload: {ready: false,}})
      const {success, user} = yield call(service.query, payload)
      const {locationPathname} = yield select(_ => _.app)
      yield put({type: 'updateState', payload: {ready: true,}})
      if (success && user) {
        yield put({
          type: 'updateState',
          payload: {
            user,
          },
        })
        if (locationPathname === '/login') {
          yield put(routerRedux.push({
            pathname: '/',
          }))
        }
      } else if (config.openPages && config.openPages.indexOf(locationPathname) < 0) {
        yield put(routerRedux.push({
          pathname: '/login',
        }))
      }
    },

    * logout({
               payload,
             }, {call, put}) {
      const data = yield call(service.logout)
      if (data.success) {
        yield put({
          type: 'updateState',
          payload: {
            user: null,
          },
        })
        yield put({type: 'query'})
      } else {
        throw (data)
      }
    },

  },
  reducers: {
    updateState(state, {payload}) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}
